module.exports = __webpack_public_path__ + "media/images/icons/country_flags/cg-ef7269ecc526c865724c6435ad106e8f.svg";